import { useRecoilValue } from 'recoil'
import navigationAtom from '../../navigation.atom'
import navCss from '../../navigation.module.css'
import sandboxAtom from '../../../Sandbox/sandbox.atom'
import { useMemo } from 'react'
import StarTile from './StarTile'

const StarNavigation = () => {
  const { rocket } = useRecoilValue(navigationAtom)
  const sandboxState = useRecoilValue(sandboxAtom)

  const rocketGroups = useMemo(() => {
    return sandboxState.groups.filter((g) => g.set === rocket)
  }, [rocket, sandboxState.groups])

  const renderStars = () => {
    return rocketGroups.map((g, index) => {
      return <StarTile index={index} group={g} key={g.id} />
    })
  }

  return <div className={navCss.horizontalScroll}>{renderStars()}</div>
}

export default StarNavigation
